import { deselectAllBreadcrumbs, deselectAllNonBreadcrumbs, } from './breadcrumb-actions.js';
/**
 * Returns breadcrumb action creators.
 *
 * @param engine - The headless engine.
 * @returns An object holding the action creators.
 *
 * @group Actions
 * @category Breadcrumb
 */
export function loadBreadcrumbActions(engine) {
    engine.addReducers({});
    return {
        deselectAllBreadcrumbs,
        deselectAllNonBreadcrumbs,
    };
}
